/**
 * Theme utility service
 * Manages theme attributes on the body element based on customer type
 */

/**
 * Set theme attribute on body element
 * @param {string} customerType - The customer type (e.g., "the_point")
 * @param {string} theme - The theme value to set (default: "dark")
 */
export const setBodyTheme = (customerType, theme = "dark") => {
  if (customerType === "the_point") {
    document.body.setAttribute("data-theme", theme);
  } else {
    document.body.removeAttribute("data-theme");
  }
};

/**
 * Remove theme attribute from body element
 */
export const removeBodyTheme = () => {
  document.body.removeAttribute("data-theme");
};

/**
 * Get current theme from body element
 * @returns {string|null} The current theme value or null
 */
export const getBodyTheme = () => {
  return document.body.getAttribute("data-theme");
};

export default {
  setBodyTheme,
  removeBodyTheme,
  getBodyTheme,
};

